import React from 'react'
import { SVGIconProps } from '../types'
const SvgPlayArrow = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M8 5v14l11-7z" />
  </svg>
)
export default SvgPlayArrow
